//Effects
import { all, put, select, takeLatest } from 'redux-saga/effects';

import {
  CREATE_OFFICE,
  CREATE_OFFICE_FAILURE,
  CREATE_OFFICE_SUCCESS,
  GET_ITEM_SUMMARY,
  GET_ITEM_SUMMARY_FAILURE,
  GET_ITEM_SUMMARY_SUCCESS,
  GET_OFFICES_LIST,
  GET_OFFICES_LIST_FAILURE,
  GET_OFFICES_LIST_SHORT,
  GET_OFFICES_LIST_SHORT_FAILURE,
  GET_OFFICES_LIST_SHORT_SUCCESS,
  GET_OFFICES_LIST_SUCCESS,
  GET_OFFICE_DETAILS,
  GET_OFFICE_DETAILS_FAILURE,
  GET_OFFICE_DETAILS_SUCCESS,
  GET_PUBLIC_ZONES_LIST,
  GET_PUBLIC_ZONES_LIST_FAILURE,
  GET_PUBLIC_ZONES_LIST_SUCCESS,
  UPDATE_OFFICE,
  UPDATE_OFFICE_FAILURE,
  UPDATE_OFFICE_SUCCESS,
} from '../../modules/constants';
import { createNotification } from '../../modules/notificationManager';
//Service
import { defaultApi } from '../../utils/axiosApi';

export function* handleGetOfficesList({ payload }) {
  const { page, office_name } = payload;
  try {
    const url = `/albait/offices/${page ? `?page=${page}` : ''}${
      office_name
        ? page
          ? `&name=${office_name}`
          : `?name=${office_name}`
        : ''
    }`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_OFFICES_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_OFFICES_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetOfficesShortList({ payload }) {
  const public_zone_id = payload?.public_zone_id;
  const secondApi = payload?.secondApi;

  try {
    const url = `/albait/offices/short/${
      public_zone_id ? `?public_zone_id=${public_zone_id}` : ''
    }`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_OFFICES_LIST_SHORT_SUCCESS,
      payload: { data: response, secondApi },
    });
  } catch (err) {
    yield put({
      type: GET_OFFICES_LIST_SHORT_FAILURE,
      payload: { err, secondApi },
    });
  }
}

export function* handleCreateOffice({ payload }) {
  try {
    const url = `/albait/offices/`;
    const formData = new FormData();
    Object.keys(payload).forEach(key => {
      if (Array.isArray(payload[key])) {
        payload[key].forEach((item, index) => {
          if (key === 'public_zone_detail') {
            Object.keys(item).forEach(subKey => {
              if (
                subKey === 'sketch_image' &&
                item[subKey] &&
                item[subKey] !== null
              ) {
                formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
              } else if (Array.isArray(item[subKey])) {
                item[subKey].forEach((nestedItem, subIndex) => {
                  if (typeof nestedItem === 'object') {
                    Object.keys(nestedItem).forEach(nestedKey => {
                      formData.append(
                        `${key}[${index}][${subKey}][${subIndex}][${nestedKey}]`,
                        nestedItem[nestedKey],
                      );
                    });
                  } else {
                    formData.append(
                      `${key}[${index}][${subKey}][${subIndex}]`,
                      nestedItem,
                    );
                  }
                });
              } else {
                formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
              }
            });
          } else {
            formData.append(`${key}[${index}]`, JSON.stringify(item));
          }
        });
      } else {
        formData.append(key, payload[key]);
      }
    });
    const response = yield defaultApi(url, 'POST', formData, {
      'Content-Type': 'multipart/form-data',
    });
    yield put({
      type: CREATE_OFFICE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: CREATE_OFFICE_FAILURE,
      payload: err,
    });
  }
}

export function* handleUpdateOffice({ payload }) {
  const { office_id, ...data } = payload;
  try {
    const url = `/albait/offices/${office_id}/`;
    const formData = new FormData();
    Object.keys(payload).forEach(key => {
      if (Array.isArray(payload[key])) {
        payload[key].forEach((item, index) => {
          if (key === 'public_zone_detail') {
            Object.keys(item).forEach(subKey => {
              if (
                subKey === 'sketch_image' &&
                item[subKey] &&
                item[subKey] !== null
              ) {
                formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
              } else if (Array.isArray(item[subKey])) {
                item[subKey].forEach((nestedItem, subIndex) => {
                  if (typeof nestedItem === 'object') {
                    Object.keys(nestedItem).forEach(nestedKey => {
                      formData.append(
                        `${key}[${index}][${subKey}][${subIndex}][${nestedKey}]`,
                        nestedItem[nestedKey],
                      );
                    });
                  } else {
                    formData.append(
                      `${key}[${index}][${subKey}][${subIndex}]`,
                      nestedItem,
                    );
                  }
                });
              } else {
                formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
              }
            });
          } else {
            formData.append(`${key}[${index}]`, JSON.stringify(item));
          }
        });
      } else {
        formData.append(key, payload[key]);
      }
    });
    const response = yield defaultApi(url, 'PUT', formData, {
      'Content-Type': 'multipart/form-data',
    });
    yield put({
      type: UPDATE_OFFICE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: UPDATE_OFFICE_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetPublicZoneList({ payload }) {
  try {
    const url = `/albait/public-zone/`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_PUBLIC_ZONES_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_PUBLIC_ZONES_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetOfficeDetails({ payload }) {
  const { officeId } = payload;
  if (!officeId) {
    createNotification('error', 'Office ID is required');
    return;
  }
  try {
    const url = `/albait/offices/${officeId}/`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_OFFICE_DETAILS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_OFFICE_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetItemSummary({ payload }) {
  const { officeId, zoneId } = payload;
  if (!officeId) {
    createNotification('error', 'Office ID is required');
    return;
  }
  if (!zoneId) {
    createNotification('error', 'Zone ID is required');
    return;
  }
  try {
    const url = `/albait/offices/${officeId}/public-zones/${zoneId}/items-summary/`;

    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_ITEM_SUMMARY_SUCCESS,
      payload: { data: response, zoneId },
    });
  } catch (err) {
    yield put({
      type: GET_ITEM_SUMMARY_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get tasks list
    takeLatest(GET_OFFICES_LIST, handleGetOfficesList),
    takeLatest(GET_PUBLIC_ZONES_LIST, handleGetPublicZoneList),
    takeLatest(GET_OFFICES_LIST_SHORT, handleGetOfficesShortList),
    takeLatest(CREATE_OFFICE, handleCreateOffice),
    takeLatest(UPDATE_OFFICE, handleUpdateOffice),
    takeLatest(GET_OFFICE_DETAILS, handleGetOfficeDetails),
    takeLatest(GET_ITEM_SUMMARY, handleGetItemSummary),
  ]);
}
